import React, { useEffect, useState, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import LineworxClient from '../../lineworxClient';

// Import module css
import styles from './Navigation.module.css';

const Navigation = () => {
  const node = useRef();

  const [open, setOpen] = useState(false);

  const handleClick = e => {
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    setOpen(false);
  };

  const handleChange = selectedValue => {
    onchange(selectedValue);
    setOpen(false);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);

    return () => {
      document.removeEventListener('mousedown', handleClick);
    }
  }, []);

  return (
    <div ref={node} className={styles.navBlock}>
      <button
        className={`navbar-toggler ${styles.navbarToggle}`}
        type="button"
        // data-toggle="collapse"
        data-target="#navbarNavAltMarkup"
        onClick={e => setOpen(!open)}
        // aria-controls="navbarNavAltMarkup"
        // aria-expanded="false"
        // aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      
      <div
        className={`collapse navbar-collapse ${styles.navbar} ${open ? `show ${styles.show}` : ''}`}
        id="navbarNavAltMarkup"
      >
        <div
          id="navbar-nav-links"
          className="navbar-nav ml-auto"
        >
          <NavLink
            className={`nav-item nav-link ${styles.navbarNavLink}`}
            activeClassName={styles.active}
            to="/Jobs"
            isActive={
              (match, location) => {
                if (location.pathname === '/job' || location.pathname === '/jobs') {
                  return true;
                }
              }
            }
            onClick={e => setOpen(false)}
          >
            Jobs <span className="sr-only">(current)</span>
          </NavLink>
          {LineworxClient.canShowCrew() &&
          <NavLink
            className={`nav-item nav-link ${styles.navbarNavLink}`}
            activeClassName={styles.active}
            to="/Crew"
            onClick={e => setOpen(false)}
          >
            Crew
          </NavLink>
          }
          {/*
          <NavLink
            className={`nav-item nav-link ${styles.navbarNavLink}`}
            activeClassName={styles.active}
            to="/Admin"
          >
            Admin
          </NavLink>
          */}
          <NavLink
            className={`nav-item nav-link ${styles.navbarNavLink}`}
            activeClassName={styles.active}
            to="/User"
            onClick={e => setOpen(false)}
          >
            User
          </NavLink>
        </div>
      </div>
    </div>
  )
}

export default Navigation;